<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 px-1">
                <div class="bg-gray2 py-2">
                    <button
                        id="legalMentions-header"
                        type="button"
                        class="ob1-link-arrow"
                        data-bs-toggle="collapse"
                        data-bs-target="#legalMentions-text"
                        aria-controls="legalMentions-text"
                        aria-expanded="false"
                    >
                        {{ legalMentions.title }}
                    </button>
                    <div
                        id="legalMentions-text"
                        class="collapse"
                        role="region"
                        aria-labelledby="legalMentions-header"
                    >
                        <p class="d-flex flex-column">
                            <span v-html="legalMentions.text.first" />
                            <br>
                            <span v-html="legalMentions.text.second" />
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'CartLegalMentions',
  props: {
    legalMentions: {
      type: Object,
      required: true,
    }
  }
}
</script>
